<template>
  <div class="page-container">
    <div class="page-header">
      <Icon icon="material-symbols:calendar-month-outline-rounded" class="page-icon" />
      <h1 class="page-title">Eventos</h1>
    </div>
    <div v-if="errorMessage" class="section-error">
      <p>{{ errorMessage }}</p>
      <button class="retry-btn" @click="fetchNews">Tentar novamente</button>
    </div>
    <NewsGrid 
      v-else 
      :news="allNews" 
      category="EVENTOS" 
      :title="null" 
      :itemsPerPage="9" 
    />
  </div>
</template>

<script>
import { Icon } from '@iconify/vue';
import NewsGrid from '../components/NewsGrid.vue';
import { getNewsByCategory } from '../data/newsData'

export default {
  name: 'EventosView',
  components: {
    Icon,
    NewsGrid
  },
  data() {
    return {
      allNews: [],
      errorMessage: ''
    }
  },
  created() {
    this.fetchNews()
  },
  methods: {
    async fetchNews() {
      this.errorMessage = ''
      try {
        this.allNews = await getNewsByCategory('EVENTOS') || []
      } catch (error) {
        console.error('Erro ao buscar eventos', error)
        this.allNews = []
        this.errorMessage = 'Não conseguimos carregar os eventos agora.'
      }
    }
  }
}
</script>

<style scoped>
.page-container {
  margin-top: 3rem;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 3rem;
}

.page-icon {
  font-size: 48px;
  color: var(--brand-cloud);
}

.page-title {
  font-size: 48px;
  font-weight: 800;
  letter-spacing: -1px;
  color: var(--brand-cloud);
  margin: 0;
  line-height: 1;
}

.section-error {
  margin-top: 2rem;
  border-radius: 16px;
  border: none;
  background: transparent;
  text-align: center;
  color: var(--brand-cloud);
  box-shadow: none;
}

.retry-btn {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  padding: 0.8rem 1.8rem;
  border: 1px solid rgba(229, 233, 253, 0.65);
  border-radius: 999px;
  background: var(--brand-navy);
  color: #f5f8ff;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 18px 35px rgba(0, 35, 73, 0.25);
}

.retry-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 24px 45px rgba(0, 35, 73, 0.32);
}

@media (max-width: 768px) {
  .page-header {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0.5rem;
    justify-content: center;
    margin-top:-40px
  }
  
  .page-icon {
    font-size: 40px;
  }
  
  .page-title {
    font-size: 32px;
  }
}
</style>
